import React, { Fragment } from 'react'
import styled from '@emotion/styled'

const Container = styled('span')`
  display: inline-block;
  width: 15px;
  text-align: left;
`

export default class SaveIndicator extends React.PureComponent {
  constructor(props) {
    super(props)
    this.state = {
      saveDots: 3,
      isAnimating: props.animate,
    }
  }

  componentDidMount() {
    const { isAnimating } = this.state
    if (isAnimating) {
      this.startAnimation()
    }
  }

  componentDidUpdate(prevProps) {
    const { animate } = this.props
    if (!prevProps.animate && animate) {
      this.startAnimation()
    }
    if (prevProps.animate && !animate) {
      this.stopAnimation()
    }
  }

  componentWillUnmount() {
    clearTimeout(this.timeout)
  }

  animateDots = () => {
    const { saveDots, isAnimating } = this.state
    if (!isAnimating) return
    let newSaveDots = saveDots + 1
    if (newSaveDots > 3) {
      newSaveDots = 0
    }
    this.setState({
      saveDots: newSaveDots,
    })
    clearTimeout(this.timeout)
    this.timeout = setTimeout(this.animateDots, 500)
  }

  startAnimation = () => {
    this.setState(
      {
        isAnimating: true,
      },
      this.animateDots
    )
  }

  stopAnimation = () => {
    clearTimeout(this.timeout)
    this.setState({
      isAnimating: false,
    })
  }

  render() {
    const { children } = this.props
    const { saveDots } = this.state
    return (
      <Fragment>
        {children}
        <Container>{'.'.repeat(saveDots)}</Container>
      </Fragment>
    )
  }
}
